export default {
  PRODUCT_REPEATER_CLASS: 'products elementor-grid columns-3',

  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',

  SELECT_YOUR_VEHICLE: 'Search By Vehicle',
  SINGLE_VEHICLE_GARAGE_CLEAR: 'X',

  SEARCH_BOX_INPUT_CLASS: 'elementor-search-form__input',
  SEARCH_BOX_PLACEHOLDER: `I'm looking for...`,
  SEARCH_BOX_CLEAR_BUTTON: 'Clear',
};
